export const extractArticleFullName = ({ productName, modelName, articleName }) => {
  productName = productName.toUpperCase()
  modelName = modelName.toUpperCase()
  articleName = articleName.toUpperCase()

  let result = productName || ''

  if (modelName.indexOf(result) > -1) {
    result = modelName
  } else if (result.indexOf(modelName) == -1) {
    result += ` ${modelName}`
  }
  if (result.indexOf(articleName) == -1) {
    result += ` ${articleName}`
  }
  return result
}

export const getModelAndArticleFromProduct = (articleSeoName, product) => {
  if (!product) {
    return {}
  }
  if (articleSeoName && articleSeoName.length > 0) {
    for (let i = 0; i < product.models.length; i++) {
      const model = product.models[i]
      for (let j = 0; j < model.articles.length; j++) {
        const article = model.articles[j]
        if (article.seoName === articleSeoName) {
          return {
            selectedModel: model,
            selectedArticle: article,
          }
        }
      }
    }
  }
  let selectedModel
  let selectedArticle
  if (!selectedModel) {
    ;[selectedModel] = product.models
  }
  if (selectedModel && !selectedArticle) {
    ;[selectedArticle] = selectedModel.articles
  }
  return {
    selectedModel,
    selectedArticle,
  }
}

export default {}
